import { memo } from 'react';
import { PosListPlaceholder } from './components/PosListPlaceholder';
import { TriggerPlaceholder } from './components/TriggerPlaceholder';
import type { HeaderSelectorSkeletonProps } from './interfaces';

export const HeaderSelectorSkeletonsRender = memo(({ posList, trigger, children }: HeaderSelectorSkeletonProps) => {
	if (posList) return <PosListPlaceholder />;

	if (trigger) return <TriggerPlaceholder />;

	return children || null;
});
